<template>
  <div class="main-box">
    <el-row>
      <!-- 管理文件 -->
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.manageCert.001') }}</span>
      </el-col>
      <!-- 管理文件-文件下载 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.manageCert.002') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageCert.003') }}</span>
        <el-button type="text" @click="openFileDownLoadUrl"> {{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <!-- <el-col :span="10" class="setting-box3">
        <span class="setTitle">{{ $t('messageAdd.manageCert.004') }}</span>
        <el-date-picker
          v-model="fileTimeValue"
          size="medium"
          type="daterange"
          :range-separator="$t('messageAdd.manageCert.005')"
          :start-placeholder="$t('messageAdd.manageCert.006')"
          :end-placeholder="$t('messageAdd.manageCert.007')"
          value-format="yyyy-MM-dd"
          @change="handleFileDateChange"
          :clearable="false"
        >
        </el-date-picker>
      </el-col> -->
      <el-col :span="24" v-show="outUrlData.length > 0">
        <el-table :data="outUrlData" border style="margin:10px 10px;">
          <el-table-column type="index" :label="$t('messageAdd.manageCert.008')" width="50">
          </el-table-column>
          <el-table-column prop="t" :label="$t('messageAdd.manageCert.009')">
            <template slot-scope="scope">
              <span>{{ scope.row.t == 0 ? $t('messageAdd.manageCert.010') : $t('messageAdd.manageCert.011') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="an" :label="$t('messageAdd.manageCert.012')">
          </el-table-column>
          <el-table-column prop="bn" :label="$t('messageAdd.manageCert.013')">
          </el-table-column>
          <el-table-column :label="$t('messageAdd.manageCert.014')">
            <template slot-scope="scope">
              <span>{{ scope.row.t == 0 ? scope.row.du : "***" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sd" :label="$t('messageAdd.manageCert.015')">
          </el-table-column>
          <el-table-column :label="$t('messageAdd.manageCert.016')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openFileDownLoad(scope.$index, scope.row)">{{
                $t('messageAdd.manageCert.017') }}</el-button>
              <el-button type="text" size="small" @click="delFileDownLoad(scope.$index)">{{
                $t('messageAdd.manageCert.018') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 管理文件-文件删除 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.manageCert.019') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageCert.020') }}</span>
        <el-button type="text" @click="openFileDeleteDialog">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="fileDel.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in fileDel" :key="i">{{
            v.fileUrl.length > 30
              ? v.fileUrl.substring(0, 29) + "..."
              : v.fileUrl
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row> -->
    <!-- 管理证书 -->
    <!-- <el-col :span="24">
      <span class="font-title">{{ $t('messageAdd.manageCert.021') }}</span>
    </el-col> -->
    <!-- 管理证书-证书下载 -->
    <!-- <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.manageCert.022') }}</span>
      </el-col>
      <el-col :span="24"></el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageCert.023') }}</span>
        <el-button type="text" @click="openCertUploadUrl">
          {{ $t("message.appDesktopMsg.add") }}
        </el-button>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle">{{ $t('messageAdd.manageCert.004')  }}</span>
        <el-date-picker
        v-model="certTimeValue"
        @change="handleCertTimeValueChange"
        size="medium"
          type="daterange"
          :range-separator="$t('messageAdd.manageCert.005') "
          :start-placeholder="$t('messageAdd.manageCert.006') "
          :end-placeholder="$t('messageAdd.manageCert.007') "
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="24" v-show="certUploadArr.length > 0">
        <el-table :data="certUploadArr" border style="margin:10px 10px;">
          <el-table-column
            type="index"
            :label="$t('messageAdd.manageCert.008') "
            width="50">
          </el-table-column>
          <el-table-column
            prop="t"
            :label="$t('messageAdd.manageCert.009') "
          >
          <template slot-scope="scope">
            <span>{{scope.row.t==0?$t('messageAdd.manageCert.010') :$t('messageAdd.manageCert.011') }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="an"
            :label="$t('messageAdd.manageCert.024') ">
          </el-table-column>
          <el-table-column
            prop="bn"
            :label="$t('messageAdd.manageCert.013') ">
          </el-table-column>
          <el-table-column
            :label="$t('messageAdd.manageCert.014') "
            >
            <template slot-scope="scope">
            <span>{{scope.row.t==0?scope.row.du:"***"}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="sd"
            :label="$t('messageAdd.manageCert.015') ">
          </el-table-column>
          <el-table-column
            :label="$t('messageAdd.manageCert.025') "
            >
            <template slot-scope="scope">
            <span>{{scope.row.i?$t('messageAdd.manageCert.026') :$t('messageAdd.manageCert.027') }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="p"
            :label="$t('messageAdd.manageCert.028') ">
          </el-table-column>
          <el-table-column
            :label="$t('messageAdd.manageCert.016') "
         >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openCertDownLoad(scope.$index,scope.row)">{{$t('messageAdd.manageCert.017') }}</el-button>
              <el-button type="text" size="small" @click="delCertDownLoad(scope.$index)">{{$t('messageAdd.manageCert.018') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col> -->
    <!-- 管理证书-证书安装 -->
    <!-- <el-col :span="24">
        <span class="secondfont-title">{{$t('messageAdd.manageCert.029') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{$t('messageAdd.manageCert.030') }}</span>
        <el-button type="text" @click="openCertInstallPathDialog">
          {{ $t("message.appDesktopMsg.add") }}
        </el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="certInstall.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in certInstall" :key="i">{{
            v.d.length > 30
              ? v.d.substring(0, 29) + "..."
              : v.d
          }}</el-tag>
        </div>
      </el-col> -->
    <!-- 管理证书-证书删除 -->
    <!-- <el-col :span="24">
        <span class="secondfont-title">{{$t('messageAdd.manageCert.031') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageCert.032') }}</span>
        <el-button type="text"  @click="openDelCertPathDialog">
          {{ $t("message.appDesktopMsg.add") }}
        </el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="dertDel.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in dertDel" :key="i">{{
            v.certName.length > 30
              ? v.certName.substring(0, 29) + "..."
              : v.certName
          }}</el-tag>
        </div>
      </el-col> -->
    <!-- </el-row> -->


    <!-- 文件下载 -->
    <el-dialog
      :title="$t('messageAdd.manageCert.039')"
      :visible.sync="outUrlDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleOutUrlClose"
      width="40%"
    >
      <!-- <div v-show="fileUploadData.t===1" style="color:red;">{{$t('messageAdd.manageApp.065')}}</div> -->
      <el-form ref="fileUrlForm" label-width="160px" :model="fileUploadData" :rules="fileUrlRules" style="margin-right:20px;">
        <el-form-item :label="$t('messageAdd.manageCert.040')" prop="t">
          <el-radio-group v-model="fileUploadData.t" @input="handleAppRadioChange">
            <el-radio :label="0">{{ $t('messageAdd.manageCert.010') }}</el-radio>
            <el-radio :label="1">{{ $t('messageAdd.manageCert.011') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.041')" v-show="fileUploadData.t === 1">
          <el-upload class="upload-demo" ref="upload" action="#" :limit="1" :on-change="handleChange"
            :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('messageAdd.manageCert.042') }}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success"
              @click="submitUpload">{{ $t('messageAdd.manageCert.043') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.012')" prop="an">
          <el-input v-model="fileUploadData.an"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.013')" prop="bn">
          <el-input v-model="fileUploadData.bn"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.014')" v-show="fileUploadData.t === 0">
          <el-input v-model="fileUploadData.du"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.015')" prop="sd">
          <el-input v-model="fileUploadData.sd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOutUrl">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 文件删除 -->
    <el-dialog 
      :title="$t('messageAdd.manageCert.033')"
      :visible.sync="whitelistDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false" 
      @close="handleFileDelClose"
    >
      <div style="width: 100%">
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="addwhitelist">{{ $t("message.systemMsg.add") }}</el-button>
      </div>
      <el-table border :data="wData">
        <el-table-column prop="id" :label="$t('message.systemMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="fileUrl" align="center" :label="$t('messageAdd.manageCert.034')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.fileUrl }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.fileUrl"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.systemMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-show="scope.row.isEdit" @click="okwhitelist(scope.row)">{{ $t("message.systemMsg.save") }}</el-button>
            <el-button type="primary" icon="el-icon-edit" @click="editwhitelist(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="delwhitelist(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savewhitelist">{{ $t("message.systemMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 证书删除 -->
    <!-- <el-dialog
      :title="$t('messageAdd.manageCert.035')"
      :visible.sync="certDeleteDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseCertDel"
    >
      <div style="width: 100%">
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="addDelCertPath">{{ $t("message.systemMsg.add") }}</el-button>
      </div>
      <el-table border :data="certDeleteData">
        <el-table-column prop="id" :label="$t('message.systemMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="certName" align="center" :label="$t('messageAdd.manageCert.036')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.certName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.certName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.systemMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-show="scope.row.isEdit" @click="okDelCertPath(scope.row)">{{
              $t("message.systemMsg.save") }}
            </el-button>
            <el-button type="primary" icon="el-icon-edit" @click="editDelCertPath(scope.row)"
              v-show="!scope.row.isEdit"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="delDelCertPath(scope.row)"
              v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDelCertPath">{{ $t("message.systemMsg.Submit") }}</el-button>
     </span>
    </el-dialog> -->
    <!-- 证书安装 -->
    <!-- <el-dialog
      :title="$t('messageAdd.manageCert.037')"
      :visible.sync="certPathDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
    >
      <div style="width: 100%">
        <el-button type="text" icon="el-icon-circle-plus-outline" @click="addCertInstallPath">{{ $t("message.systemMsg.add") }}</el-button>
      </div>
      <el-table border :data="certPathData">
        <el-table-column prop="id" :label="$t('message.systemMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="d" align="center" :label="$t('messageAdd.manageCert.038')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.d }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.d"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="an" align="center" :label="$t('messageAdd.manageCert.012')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.an }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.an"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="p" align="center" :label="$t('messageAdd.manageCert.028')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.p }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.p"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.systemMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-show="scope.row.isEdit" @click="okCertInstallPath(scope.row)">{{
              $t("message.systemMsg.save") }}
            </el-button>
            <el-button type="primary" icon="el-icon-edit" @click="editCertInstallPath(scope.row)"
              v-show="!scope.row.isEdit"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="delCertInstallPath(scope.row)"
              v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCertInstallPath">{{ $t("message.systemMsg.Submit") }}</el-button>
      </span>
    </el-dialog> -->
    <!-- 证书下载 -->
    <!-- <el-dialog
      :title="$t('messageAdd.manageCert.044')"
      :visible.sync="certUploadDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCertUploadClose"
      width="40%"
    >
       // <div v-show="certUploadData.t===1" style="color:red;">{{$t('messageAdd.manageApp.065')}}</div>
      <el-form ref="certUrlForm" label-width="160px" :model="certUploadData" :rules="certUrlRules" style="margin-right:20px;">
        <el-form-item :label="$t('messageAdd.manageCert.040')" prop="t">
          <el-radio-group v-model="certUploadData.t" @input="handleCertRadioChange">
            <el-radio :label="0">{{ $t('messageAdd.manageCert.010') }}</el-radio>
            <el-radio :label="1">{{ $t('messageAdd.manageCert.011') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.041')" v-show="certUploadData.t === 1">
          <el-upload class="upload-demo" ref="upload" action="#" :limit="1" :on-change="handleCertChange"
            :on-remove="handleCertRemove" :file-list="certfileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('messageAdd.manageCert.042') }}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success"
              @click="submitCertUpload">{{ $t('messageAdd.manageCert.043') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.012')" prop="an">
          <el-input v-model="certUploadData.an"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.013')" prop="bn">
          <el-input v-model="certUploadData.bn"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.014')" v-show="certUploadData.t === 0">
          <el-input v-model="certUploadData.du"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.015')" prop="sd">
          <el-input v-model="certUploadData.sd"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.025')" prop="i">
          <el-select v-model="certUploadData.i">
            <el-option :label="$t('messageAdd.manageCert.026')" :value="true"></el-option>
            <el-option :label="$t('messageAdd.manageCert.027')" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageCert.028')" prop="p">
          <el-input v-model="certUploadData.p" :disabled="certUploadData.i ? false : true"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCertUploadData">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import { uploadFile } from "@/api/stage";
import { EventBus } from '@/utils/event-bus';
export default {
  name: "ManageFileCert",
  data() {
    return {
      // 总数据
      mf: {
        // 管理文件
        mf: {
          fd: [],//文件下载
          t: "",
        },
        // 管理证书
        // mc: {
        //   ic: [],//安装证书
        //   t: ""
        // }
      },
      editIndex: 0,

      whitelistDialogVisible: false, //文件删除弹框
      wData: [],//文件删除列表
      fileDel: [], // 文件删除列表
      outUrlDialogVisible: false,//文件下载弹框
      outUrlData: [],//文件下载列表
      fileUploadData: {
        an: "",
        t: 0,
        sd: "/sdcard/StageNow",
        du: "",
        bn: "",
      },//文件上传表单数据
      fileList: [], // 文件删除上传列表
      filemode: "", // add新增 edit编辑
      // fileTimeValue: [], // 文件下载时间筛选

      // certPathDialogVisible: false,//证书安装弹框
      // certPathData: [],//证书安装列表
      // certInstall: [], // 证书安装列表
      // certDeleteDialogVisible: false,//证书删除弹框
      // certDeleteData: [],//证书删除列表
      // dertDel: [] // 证书删除列表
      // certUploadDialogVisible: false,//证书下载弹框
      // certUploadArr: [],//证书下载列表
      // certUploadData: {
      //   t: 0,
      //   an: "",
      //   bn: "",
      //   du: "",
      //   sd: "/sdcard/StageNow",
      //   i: true,//是否安装
      //   p: ''
      // }, // 证书上传表单数据
      // certfileList: [], // 证书下载上传列表
      // certMode: "", // 证书下载操作类型 add新增 edit编辑
      // certTimeValue: [], // 证书下载时间筛选
    };
  },
  computed: {
    // 表单校验
    // certUrlRules() {
    //   return {
    //     t: [
    //       { required: true, message: this.$t('messageAdd.manageCert.045'), trigger: 'change' }
    //     ],
    //     sd: [
    //       { required: true, message: this.$t('messageAdd.manageCert.046'), trigger: 'blur' }
    //     ],
    //     an: [
    //       { required: true, message: this.$t('messageAdd.manageCert.047'), trigger: 'blur' }
    //     ],
    //     bn: [
    //       { required: true, message: this.$t('messageAdd.manageCert.048'), trigger: 'blur' }
    //     ]
    //   }
    // },
    fileUrlRules() {
      return {
        t: [
          { required: true, message: this.$t('messageAdd.manageCert.045'), trigger: 'change' }
        ],
        sd: [
          { required: true, message: this.$t('messageAdd.manageCert.046'), trigger: 'blur' }
        ],
        an: [
          { required: true, message: this.$t('messageAdd.manageCert.047'), trigger: 'blur' }
        ],
        bn: [
          { required: true, message: this.$t('messageAdd.manageCert.048'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // =====================================文件删除 start=====================================
    // 打开管理文件删除弹框
    openFileDeleteDialog() {
      this.whitelistDialogVisible = true; // 打开弹框
      if (localStorage.getItem('mf')) {
        const dfString = JSON.parse(localStorage.getItem('mf'))?.mf?.df;
        // 使用 split 方法按逗号分割字符串
        if (dfString) {
          this.wData = [];
          // 这里假设每个项目就是一个简单的字符串，直接作为 fileUrl 添加到对象中
          dfString.forEach(item => {
            // 去除可能的空白字符
            const trimmedItem = item.trim();
            // 添加到 wData 数组中，这里假设只有 fileUrl 字段
            this.wData.push({ fileUrl: trimmedItem, isEdit: false }); // 可以根据需要添加其他字段
          });
        }
      }
    },
    // 新增方法
    addwhitelist() {
      // 假设新增时添加一行默认数据
      this.wData.push({ fileUrl: '', isEdit: true });
    },
    // 编辑方法
    editwhitelist(row) {
      row.isEdit = true; // 设置当前行为编辑状态
    },
    // 保存方法
    okwhitelist(row) {
      this.mf.mf.df = this.wData.map(item => item.fileUrl).join(',');
      row.isEdit = false;
    },
    // 删除方法
    delwhitelist(row) {
      const index = this.wData.indexOf(row);
      if (index !== -1) {
        this.wData.splice(index, 1);
      }
    },
    savewhitelist() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.wData.some(item => !item.fileUrl);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageCert.058'));
        return;
      }
      // 读取 localStorage 中的 mf 数据（如果有）
      const mfData = JSON.parse(localStorage.getItem("mf") || '{}');
      if (mfData?.mf?.df) {
        this.mf.mf.df = mfData?.mf?.df;
      }
      // 更新 mf 数据
      this.mf.mf.df = this.wData.map(item => item.fileUrl);
      this.whitelistDialogVisible = false;
      localStorage.setItem("mf", JSON.stringify(this.mf));
      this.fileDel = [...this.wData]
    },
    handleFileDelClose() {
      if (localStorage.getItem("mf")) {
        const mfData = JSON.parse(localStorage.getItem("mf") || '{}');
        if (mfData.mf.df) {
          const items = mfData.mf.df;
          items.forEach(item => {
            const trimmedItem = item.trim();
            this.wData.push({ fileUrl: trimmedItem, isEdit: false }); // 可以根据需要添加其他字段
          });
        }
      }
      else {
        this.wData = [];
      }
    },
    // =====================================文件删除 end=======================================
    // =====================================文件下载 start=====================================
    // handleFileDateChange(value){
    //    // 当日期范围变化时触发
    //    if (value && value.length === 2) {
    //     this.mf.mf.t = `${value[0]}~${value[1]}`;
    //       // 保存至方案
    //     localStorage.setItem("mf",JSON.stringify(this.mf));
    //   } 
    // }
    // 打开管理文件弹框
    openFileDownLoadUrl() {
      this.outUrlDialogVisible = true;
      this.filemode = "add";
    },
    // 选择服务器类型
    handleAppRadioChange(val) {
      this.fileUploadData = {
        t: val,
        an: "",
        sd: "/sdcard/StageNow",
        du: "",
        bn: "",
      }
      this.fileList = [];
    },
    // 上传文件
    handleChange(file, fileList) {
      if (file) {
        this.fileUploadData.an = file.name.split('.')[0];
      }
      this.fileList = fileList;
    },
    handleRemove() {
      this.fileUploadData.an = '';
    },
    submitUpload() {
      // 大小
      const maxSize = 50 * 1024 * 1024;
      const count = this.outUrlData.reduce((acc, item) => item.t === 1 ? acc + 1 : acc, 0);
      if (this.fileList[0].size > maxSize) {
        this.$message.error(this.$t('messageAdd.manageCert.059'));
        this.fileList = [];
        this.fileUploadData.an = '';
        return; // 停止进一步处理
      } else if (count >= 30) {
        // 数量不超过30个
        this.$message.error(this.$t('messageAdd.manageCert.062'));
        this.fileList = [];
        this.fileUploadData.an = '';
        this.outUrlDialogVisible = false;
        return; // 停止进一步处理
      } else {
        let formData = new FormData();
        if (this.fileList.length > 0) {
          formData.append('fileList', this.fileList[0].raw);
        }
        formData.append('type', 2);
        const loading = this.$loading({
          lock: true,
          text: this.$t('messageAdd.manageCert.049'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        uploadFile(formData, 2).then(res => {
          if (res.success) {
            loading.close();
            this.fileUploadData.id = res.data[0].id;
            this.fileUploadData.md5 = res.data[0].md5;
            // 后期URL需要加密
            this.fileUploadData.du = res.data[0].url;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.manageCert.050'));
          } else {
            loading.close();
            this.$message.closeAll();
            this.$message.error(this.$t(`code.${res.errorCode}`) + res.errorInfo ? res.errorInfo : '');
          }
        })
      }
    },
    saveOutUrl() {
      if (this.fileUploadData.t === 1 && this.fileUploadData.id === undefined) {
        this.$message.error(this.$t('messageAdd.manageCert.051'));
        return;
      }
      this.$refs["fileUrlForm"].validate((valid) => {
        if (valid) {
          if (this.filemode === "add") {
            this.outUrlData.push(this.fileUploadData);
            this.fileList = [];
            this.$refs['fileUrlForm'].clearValidate();
            this.fileUploadData = {
              t: 0,
              an: "",
              sd: "/sdcard/StageNow",
              du: "",
              bn: "",
            }
          } else if (this.filemode === "edit") {
            this.outUrlData.splice(this.editIndex, 1, this.fileUploadData);
            this.fileList = [];
            this.$refs['fileUrlForm'].clearValidate();
            this.fileUploadData = {
              t: 0,
              an: "",
              sd: "/sdcard/StageNow",
              du: "",
              bn: "",
            }
          }
          this.outUrlDialogVisible = false;
        }
      })
      // 读取 localStorage 中的 mf 数据（如果有）
      const mfData = JSON.parse(localStorage.getItem("mf") || '{}');
      if (mfData?.mf?.fd) {
        this.mf.mf.fd = mfData.mf.fd;
      }
      // 更新 mf 数据
      this.mf.mf.fd = [...this.outUrlData];
      localStorage.setItem("mf", JSON.stringify(this.mf));
    },
    handleOutUrlClose() {
      this.outUrlDialogVisible = false;
      this.$refs['fileUrlForm'].clearValidate();
      this.fileList = [];
      this.fileUploadData = {
        t: 0,
        an: "",
        sd: "/sdcard/StageNow",
        du: "",
        bn: "",
      }
    },
    delFileDownLoad(index) {
      this.$confirm(this.$t('messageAdd.manageCert.052'), this.$t('messageAdd.manageCert.053'), {
        confirmButtonText: this.$t('messageAdd.manageCert.054'),
        cancelButtonText: this.$t('messageAdd.manageCert.055'),
        type: 'warning'
      }).then(() => {
        this.outUrlData.splice(index, 1);
        // 读取 localStorage 中的 mf 数据（如果有）
        let mfData = JSON.parse(localStorage.getItem("mf") || '{}');
        if (mfData?.mf?.fd) {
          this.mf.mf.fd = mfData.mf.fd;
        }
        // 更新 mf 数据
        this.mf.mf.fd = [...this.outUrlData];
        localStorage.setItem("mf", JSON.stringify(this.mf));
        this.$message.success(this.$t('messageAdd.manageCert.056'));
      }).catch(() => {
        this.$message.info(this.$t('messageAdd.manageCert.057'));
      });
    },
    openFileDownLoad(index, data) {
      this.filemode = "edit";
      this.editIndex = index;
      this.fileUploadData = { ...data };
      this.outUrlDialogVisible = true;
    },
    // =========================================文件下载 end=====================================
    // =========================================证书下载 start===================================
    // openCertUploadUrl() {
    //   this.certUploadDialogVisible = true;
    //   this.certMode = 'add';
    // },
    // handleCertRadioChange(val) {
    //   this.certUploadData = {
    //     t: val,
    //     an: "",
    //     bn: "",
    //     du: "",
    //     sd: "/sdcard/StageNow",
    //     i: true,//是否安装
    //     p: ''
    //   };
    //   this.certfileList = [];
    // },
    // handleCertChange(file, fileList) {
    //   if (file) {
    //     this.certUploadData.an = file.name.split('.')[0];
    //   }
    //   this.certfileList = fileList;
    // },
    // handleCertRemove() {
    //   this.certUploadData.an = '';
    // },
    // submitCertUpload() {
    //   // 调用uploadFile接口使用formData上传文件
    //   // 大小
    //   const maxSize = 5 * 1024 * 1024;
    //   const count = this.certUploadArr.reduce((acc, item) => item.t === 1 ? acc + 1 : acc, 0);
    //   if (this.certfileList[0].size > maxSize) {
    //     this.$message.error(this.$t('messageAdd.manageCert.061'));
    //     this.certfileList = [];
    //     this.certUploadData.an = '';
    //     return; // 停止进一步处理
    //   } else if (count >= 10) {
    //     // 数量不超过10个
    //     this.$message.error(this.$t('messageAdd.manageCert.060'));
    //     this.certfileList = [];
    //     this.certUploadData.an = '';
    //     this.certUploadDialogVisible = false;
    //     return; // 停止进一步处理
    //   } else {
    //     let formData = new FormData();
    //     if (this.certfileList.length > 0) {
    //       formData.append('fileList', this.certfileList[0].raw);
    //     }
    //     formData.append('type', 3);
    //     const loading = this.$loading({
    //       lock: true,
    //       text: this.$t('messageAdd.manageCert.049'),
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(0, 0, 0, 0.7)'
    //     });
    //     uploadFile(formData, 3).then(res => {
    //       if (res.success) {
    //         loading.close();
    //         this.certUploadData.id = res.data[0].id;
    //         this.certUploadData.md5 = res.data[0].md5;
    //         // 后期URL需要加密
    //         this.certUploadData.du = res.data[0].url;
    //         this.$message.closeAll();
    //         this.$message.success(this.$t('messageAdd.manageCert.050'));
    //       } else {
    //         loading.close();
    //         this.$message.closeAll();
    //         this.$message.error(this.$t(`code.${res.errorCode}`) + res.errorInfo ? res.errorInfo : '');
    //       }
    //     })
    //   }
    // },
    // saveCertUploadData() {
    //   if (this.certUploadData.t === 1 && this.certUploadData.id === undefined) {
    //     this.$message.error(this.$t('messageAdd.manageCert.051'));
    //     return;
    //   }
    //   this.$refs["certUrlForm"].validate((valid) => {
    //     if (valid) {
    //       if (this.certMode === "add") {
    //         this.certUploadArr.push(this.certUploadData);
    //         this.certfileList = [];
    //         this.$refs['certUrlForm'].clearValidate();
    //         this.certUploadData = {
    //           t: 0,
    //           an: "",
    //           bn: "",
    //           du: "",
    //           sd: "/sdcard/StageNow",
    //           i: true,//是否安装
    //           p: ''
    //         }
    //       } else if (this.certMode === "edit") {
    //         this.certUploadArr.splice(this.editIndex, 1, this.certUploadData);
    //         this.fileList = [];
    //         this.$refs['certUrlForm'].clearValidate();
    //         this.certUploadData = {
    //           t: 0,
    //           an: "",
    //           bn: "",
    //           du: "",
    //           sd: "/sdcard/StageNow",
    //           i: true,//是否安装
    //           p: ''
    //         }
    //       }
    //       this.certUploadDialogVisible = false;
    //     }
    //   })
    //   // 读取 localStorage 中的 mf 数据（如果有）
    //   let mfData = localStorage.getItem("mf");
    //   if (mfData) {
    //     this.mf = JSON.parse(mfData); // 解析为对象
    //   }
    //   // 更新 mf 数据
    //   this.mf.mc.wd = [...this.certUploadArr];
    //   localStorage.setItem("mf", JSON.stringify(this.mf));

    // },
    // openCertDownLoad(index, data) {
    //   this.certMode = "edit";
    //   this.editIndex = index;
    //   this.certUploadData = { ...data };
    //   this.certUploadDialogVisible = true;
    // },
    // delCertDownLoad(index) {
    //   this.$confirm(this.$t('messageAdd.manageCert.052'), this.$t('messageAdd.manageCert.053'), {
    //     confirmButtonText: this.$t('messageAdd.manageCert.054'),
    //     cancelButtonText: this.$t('messageAdd.manageCert.055'),
    //     type: 'warning'
    //   }).then(() => {
    //     this.certUploadArr.splice(index, 1);
    //     // 读取 localStorage 中的 mf 数据（如果有）
    //     let mfData = localStorage.getItem("mf");
    //     if (mfData) {
    //       this.mf = JSON.parse(mfData); // 解析为对象
    //     }
    //     // 更新 mf 数据
    //     this.mf.mc.wd = [...this.certUploadArr];
    //     localStorage.setItem("mf", JSON.stringify(this.mf));
    //     this.$message({
    //       type: 'success',
    //       message: this.$t('messageAdd.manageCert.056')
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: this.$t('messageAdd.manageCert.057')
    //     });
    //   });
    // },
    // handleCertUploadClose() {
    //   this.certUploadDialogVisible = false;
    //   this.$refs['certUrlForm'].clearValidate();
    //   this.certfileList = [];
    //   this.certUploadData = {
    //     t: 0,
    //     an: "",
    //     bn: "",
    //     du: "",
    //     sd: "/sdcard/StageNow",
    //     i: true,//是否安装
    //     p: ''
    //   }
    // },
    // =========================================证书下载 end=======================================
    // =========================================证书删除 start=====================================
    // handleCertTimeValueChange(value) {
    //   // 当日期范围变化时触发
    //   if (value && value.length === 2) {
    //     this.mf.mc.t = `${value[0]}~${value[1]}`;
    //     // 保存至方案
    //     localStorage.setItem("mf", JSON.stringify(this.mf));
    //   }
    // },
    // 打开证书删除弹框
    // openDelCertPathDialog() {
    //   this.certDeleteDialogVisible = true; // 打开弹框
    //   if (localStorage.getItem("mf")) {
    //     // 使用 split 方法按逗号分割字符串
    //     const rString = JSON.parse(localStorage.getItem('mf')).mc.r;
    //     if (rString) {
    //       this.certDeleteData = [];
    //       rString.forEach(item => {
    //         // 去除可能的空白字符
    //         const trimmedItem = item.trim();
    //         // 添加到 certDeleteData 数组中，这里假设只有 filrUrl 字段
    //         this.certDeleteData.push({ certName: trimmedItem, isEdit: false }); // 可以根据需要添加其他字段
    //       });
    //     }
    //   }
    // },
    // 新增方法
    // addDelCertPath() {
    //   // 假设新增时添加一行默认数据
    //   this.certDeleteData.push({ certName: '', isEdit: true });
    // },
    // 编辑方法
    // editDelCertPath(row) {
    //   row.isEdit = true; // 设置当前行为编辑状态
    // },
    // 保存方法
    // okDelCertPath(row) {
    //   this.mf.mc.r = this.certDeleteData.map(item => item.certName).join(',');
    //   row.isEdit = false;
    // },
    // 删除方法
    // delDelCertPath(row) {
    //   const index = this.certDeleteData.indexOf(row);
    //   if (index !== -1) {
    //     this.certDeleteData.splice(index, 1);
    //   }
    // },
    // saveDelCertPath() {
    //   const isEmptyFileUrl = this.certDeleteData.some(item => !item.certName);
    //   if (isEmptyFileUrl) {
    //     this.$message.error(this.$t('messageAdd.manageCert.064'));
    //     return;
    //   }
    //   // 读取 localStorage 中的 mf 数据（如果有）
    //   let mfData = localStorage.getItem("mf");
    //   if (mfData) {
    //     this.mf = JSON.parse(mfData); // 解析为对象
    //   }

    //   // 更新 mf 数据
    //   this.mf.mc.r = this.certDeleteData.map(item => item.certName);

    //   this.certDeleteDialogVisible = false;
    //   localStorage.setItem("mf", JSON.stringify(this.mf));
    //   this.dertDel = [...this.certDeleteData];
    // },
    // 关闭证书删除弹框
    // handleCloseCertDel() {
    //   if (localStorage.getItem("mf")) {
    //     const mfData = JSON.parse(localStorage.getItem("mf"));
    //     if (mfData.mc.r) {
    //       const items = mfData.mc.r;
    //       items.forEach(item => {
    //         const trimmedItem = item.trim();
    //         this.certDeleteData.push({ certName: trimmedItem, isEdit: false }); // 可以根据需要添加其他字段
    //       });
    //     }
    //   }
    //   else {
    //     this.certDeleteData = [];
    //   }
    // },
    // =========================================证书删除 end======================================
    // =========================================证书安装 start====================================
    // openCertInstallPathDialog() {
    //   if (localStorage.getItem("mf")) {
    //     const certArr = JSON.parse(localStorage.getItem('mf')).mc.ic;//获取数组
    //     if (certArr.length > 0) {
    //       this.certPathData = [...certArr];
    //       // 在打开弹框前给 certPathData 加上 isEdit 属性
    //       this.certPathData = this.certPathData.map(item => ({ ...item, isEdit: false }));
    //       this.certPathDialogVisible = true;
    //     } else {
    //       this.certPathDialogVisible = true;
    //     }
    //   } else {
    //     this.certPathDialogVisible = true;
    //   }
    // },
    // 新增方法
    // addCertInstallPath() {
    //   this.certPathData.push({ d: '', p: '', an: '', isEdit: true });
    // },
    // 编辑方法
    // editCertInstallPath(row) {
    //   row.isEdit = true; // 设置当前行为编辑状态
    // },
    // 保存方法
    // okCertInstallPath(row) {
    //   this.mf.mc.ic = [...this.certPathData];
    //   row.isEdit = false;
    // },
    // 删除方法
    // delCertInstallPath(row) {
    //   const index = this.certPathData.indexOf(row);
    //   if (index !== -1) {
    //     this.certPathData.splice(index, 1);
    //   }
    // },
    // saveCertInstallPath() {
    //   const isEmptyFileUrl = this.certPathData.some(item => !item.d);
    //   if (isEmptyFileUrl) {
    //     this.$message.error(this.$t('messageAdd.manageCert.058'));
    //     return;
    //   }
    //   // 在保存前删除 certPathData 的 isEdit 属性
    //   this.certPathData = this.certPathData.map(item => {
    //     const { isEdit, ...rest } = item; // 使用解构赋值去除 isEdit 属性
    //     return rest;
    //   });
    //   // 读取 localStorage 中的 mf 数据（如果有）
    //   let mfData = localStorage.getItem("mf");
    //   if (mfData) {
    //     this.mf = JSON.parse(mfData); // 解析为对象
    //   }
    //   // 更新 mf 数据
    //   this.mf.mc.ic = [...this.certPathData];
    //   this.certPathDialogVisible = false;
    //   localStorage.setItem("mf", JSON.stringify(this.mf));
    //   this.certInstall = [...this.certPathData]
    // },
    // ========================================证书安装 end======================================
  },
  created() {
    EventBus.$on('clearMFdata', () => {
      // 清空当前页面的数据
      this.mf = { 
        mf: { fd: [], t: "", }, 
        // mc: { ic: [], t: "" } 
      };
      this.wData = [];
      this.fileDel = [];
      this.outUrlData = [];
      this.fileList = [];
      // this.certPathData = [];
      // this.certInstall = [];
      // this.certDeleteData = [];
      // this.dertDel = [];
      // this.certUploadArr = [];
      // this.certfileList = [];
    })

    // 从已保存数据回显至当前页面
    const data = JSON.parse(localStorage.getItem('mf'));
    if (data) {
      if (data.mf?.fd) {
        if (data.mf.fd.length > 0) {
          this.outUrlData = JSON.parse(JSON.stringify(data.mf.fd));
        }
      }
      if (data.mf?.df) {
        if (data.mf.df.length > 0) {
          data.mf.df.map(i => {
            this.fileDel.push({ fileUrl: i })
          })
        }
      }
      // if(data.mc?.wd){
      //   if(data.mc.wd.length>0){
      //     this.certUploadArr=JSON.parse(JSON.stringify(data.mc.wd));
      //   }
      // }
      // if(data.mc?.r){
      //   if(data.mc.r.length>0){
      //     data.mc.r.map(i=>{
      //       this.dertDel.push({certName:i})
      //     })
      //   }
      // }
      // if(data?.mc?.ic){
      //   if(data.mc.ic.length>0){
      //     this.certInstall=JSON.parse(JSON.stringify(data.mc.ic));
      //   }
      // }
    }
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器，避免内存泄漏
    EventBus.$off('clearMFdata');
  }
}
</script>